import React, { useState, useEffect } from "react";
import Header from "../../components/Header";
import Leftnav from "../../components/Leftnav";
import Rightchat from "../../components/Rightchat";
import Appfooter from "../../components/Appfooter";
import Popupchat from "../../components/Popupchat";
import {
  collection,
  query,
  where,
  getDocs,
  getDoc,
  doc,
  orderBy,
  onSnapshot,
} from "firebase/firestore";
import { firestore } from "../../components/firebase/FirebaseConfig";
import { useSelector } from "react-redux";
import "./Caddie.css";
import ModalCaddieDetail from "./component/ModalCaddieDetail";
import ModalFilter from "./ModalFilter";
import { useNavigate } from "react-router-dom";
import { Highlight } from "react-instantsearch";
import axios from "axios";
import { favFriendCaddie, favFriend } from "../../components/friend/FavFriend";
import StackFilter from "./component/StackFilter";
import CaddieCard from "./component/CaddieCard";
import Label from "../createlabel/Label";
import CaddieSearch from "./component/CaddieSearch";
import LoadCircle from "../../components/LoadCircle";
import { ChatTo } from "../../components/chat/Chat";
import { useTranslation } from "react-i18next";
import { textConvert } from "../../components/language/dropdown/textconvert";

import { getData } from "./module/getData";
import Load from "../../components/Load";
import algoliasearch from "algoliasearch/lite";

const calculateDistance = (lat1, lon1, lat2, lon2) => {
  const R = 6371; // Radius of the Earth in kilometers
  const dLat = (lat2 - lat1) * (Math.PI / 180);
  const dLon = (lon2 - lon1) * (Math.PI / 180);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * (Math.PI / 180)) *
      Math.cos(lat2 * (Math.PI / 180)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c; // Distance in kilometers
  return distance;
};

function Caddie() {
  const { t } = useTranslation();

  const userData = useSelector((state) => state.user.data);

  const [caddieList, setCaddieList] = useState([]);
  const [courseData, setCourseData] = useState();
  const [show, setShow] = useState(false);
  const [filteredCaddieList, setFilteredCaddieList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [caddieData, setCaddieData] = useState({});
  const [favoriteFriendsList, setFavoriteFriendsList] = useState({});
  const [caddieProfile, setCaddieProfile] = useState({});
  const [userLabels, setUserLabels] = useState([]);
  const [listUserBlocked, setListUserBolcked] = useState([]);
  const [selectedUserLabel, setSelectedUserLabel] = useState(null);
  const [showLabelModal, setShowLabelModal] = useState(false);
  const [triggerFriendList, setTriggerFriendList] = useState(true);
  const [triggerGetLabel, setTriggerGetLabel] = useState(false);
  const [originalCaddieList, setOriginalCaddieList] = useState([]);
  const [openSearch, setOpenSearch] = useState(false);
  const [listIdDescription, setListIdDescription] = useState([]);
  const [userLocation, setUserLocation] = useState(null);
  const [triggerSearch, setTriggerSearch] = useState(false);
  const [favFriendsId, setFavFriendsId] = useState([]);

  const [searchInput, setSearchInput] = useState("");

  const [sortData, setSortData] = useState({
    isLabel: { state: false, selectedLabels: [] },
    isFavorites: { state: false },
    isStar: { state: false },
    isPro: { state: false },
    age: { state: false, min: 18, max: 40 },
    isBlocks: { state: false },
  });
  const navigate = useNavigate();

  const [tempSortData, setTempSortData] = useState({
    isLabel: { state: true, selectedLabels: [] },
    isFavorites: { state: true },
    isStar: { state: true },
    isPro: { state: true },
    age: { state: true, min: 18, max: 40 },
    isBlocks: { state: true },
  });

  const [search, setSearch] = useState({
    province: {
      state: false,
      value: "",
    },
    text: {
      state: false,
      value: "",
    },
    nearMe: {
      state: false,
    },
  });

  const trueStates = Object.keys(sortData).filter(
    (key) => sortData[key].state === true
  );

  const [page, setPage] = useState(0); // ใช้ page สำหรับ pagination
  const [hasMore, setHasMore] = useState(true); // เช็คว่าโหลดข้อมูลครบหรือยัง
  const [error, setError] = useState(null);
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    async function fetchData() {
      const q = query(
        collection(firestore, "labels"),
        where("userId", "==", userData.uid)
      );
      const querySnapshot = await getDocs(q);
      let dataArray = [];
      querySnapshot.forEach((doc2) => {
        const data = doc2.data();
        dataArray.push({ docId: doc2.id, ...data });
      });
      setUserLabels(dataArray);

      const queryFavFriends = query(
        collection(firestore, "favoriteFriends"),
        where("userId", "==", userData.uid),
        where("status", "==", "active")
      );
      const querySnapshotFavFriends = await getDocs(queryFavFriends);
      let dataArrayFavFriend = [];
      querySnapshotFavFriends.forEach((doc2) => {
        const data = doc2.data();
        dataArrayFavFriend.push(doc2.data().caddieId);
      });
      setFavFriendsId(dataArrayFavFriend);
    }
    if (userData) {
      fetchData();
    }
  }, [userData, triggerGetLabel]);

  useEffect(() => {
    const searchClient = algoliasearch(
      "RJJNPL7MRL",
      "bb21db75be816cbedc8dd1b5838e4bba"
    );
    const usersIndex = searchClient.initIndex("users");
    const caddieProfilesIndex = searchClient.initIndex("caddieProfiles");
    const courseIndex = searchClient.initIndex("courses");
    const caddieRequestsIndex = searchClient.initIndex("caddieRequests");
    const labeledUsersIndex = searchClient.initIndex("labeledUsers");

    const getCurrentLocation = () => {
      return new Promise((resolve, reject) => {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => resolve(position.coords),
            (error) => reject(error)
          );
        } else {
          reject(new Error("Geolocation not supported"));
        }
      });
    };

    const fetchCaddies = async () => {
      setLoading(true);
      try {
        const querySearch = search.text.state ? search.text.value : "";
        const queryProvince = search.province.state
          ? search.province.value
          : "";
        const queryNearMe = search.nearMe.state;
        const querySort = sortData;
        let filters = [];
        // console.log(querySort)
        let testFirstName =
          "Por, Crystal, Felecia, Genesis, Isobel, Jane, Judy_, June, Nicole, Pus, Nicole, Sonia";
        let firstNamesArray = testFirstName
          .split(", ")
          .map((name) => `[ทดสอบระบบ]${name}`);
        filters = [
          "role:caddie",
          `NOT firstName:${firstNamesArray.join(" AND NOT firstName:")}`,
        ];
        let courseIdsFilter = "";
        let caddieUidsFilter = "";
        let nearMeFilter = "";

        if (querySort.isStar.state) {
          filters.push("isStar:true");
        }

        if (querySort.isPro.state) {
          filters.push("isPro:true");
        }

        if (
          querySort.isLabel.state &&
          querySort.isLabel.selectedLabels.length > 0
        ) {
          const labelIdsFilter = querySort.isLabel.selectedLabels
            .map((label) => `labels:"${label.id}"`) // ต้องใส่เครื่องหมายคำพูดรอบค่า
            .join(" OR "); // ใช้ OR เพื่อให้ Algolia ค้นหาค่าที่ตรงกับ array ใด ๆ

          const labeledUsersQuery = await labeledUsersIndex.search("", {
            filters: labelIdsFilter, // ใช้ filters เพื่อค้นหา
          });

          const caddieIds = labeledUsersQuery.hits.map(
            (caddie) => caddie.friendId
          );
          const caddieIdsFilter = caddieIds
            .map((id) => `uid:"${id}"`) // ต้องใส่เครื่องหมายคำพูดรอบค่า
            .join(" OR ");

          filters.push(`(${caddieIdsFilter})`);
        }

        if (querySort.isFavorites.state && favFriendsId.length > 0) {
          const favFriendsFilter = favFriendsId
            .map((id) => `uid:"${id}"`) // ต้องใส่เครื่องหมายคำพูดรอบค่า
            .join(" OR ");

          filters.push(`(${favFriendsFilter})`);
        }

        if (querySort.age.state) {
          const minAgeYear = currentYear - sortData.age.max;
          const maxAgeYear = currentYear - sortData.age.min;

          // สร้าง array ของปีที่ต้องการ
          const yearsToFilter = [];
          for (let year = minAgeYear; year <= maxAgeYear; year++) {
            yearsToFilter.push(`birthDate.year:${year}`);
          }

          yearsToFilter.sort((a, b) => {
            const yearA = parseInt(a.split(":")[1]);
            const yearB = parseInt(b.split(":")[1]);
            return yearB - yearA; // เรียงจากมากไปน้อย
          });

          // รวม filter เป็น OR
          const yearFilter = yearsToFilter.join(" OR ");

          // เพิ่ม filter ใน query
          filters.push(yearFilter);
        }
        // ค้นหาตำแหน่งของผู้ใช้ ถ้าต้องการค้นหาใกล้เคียง
        if (queryNearMe) {
          const location = await getCurrentLocation();
          const { latitude, longitude } = location;
          // ค้นหาคอร์สที่ใกล้เคียงที่สุด
          const courseQuery = await courseIndex.search("", {
            aroundLatLng: `${latitude},${longitude}`,
            aroundRadius: 10000, // กำหนดระยะห่าง (เช่น 10 กิโลเมตร)
          });
          const courseIds = courseQuery.hits.map((course) => course.id);

          if (courseIds.length > 0) {
            courseIdsFilter = courseIds
              .map((id) => `courseId:"${id}"`)
              .join(" OR ");
            const caddieRequestsQuery = await caddieRequestsIndex.search(
              querySearch,
              {
                filters: `NOT status:"removed" AND (${courseIdsFilter})`,
              }
            );
            const caddieUids = caddieRequestsQuery.hits.map(
              (caddie) => caddie.caddieId
            );
            nearMeFilter = caddieUids.map((uid) => `uid:"${uid}"`).join(" OR ");
            // console.log(nearMeFilter);

            filters.push(`(${nearMeFilter})`);
          } else {
            setCaddieList([]); // ถ้าไม่มี course ใกล้เคียง
            setLoading(false);
            return;
          }
        }
        // ถ้ามีการค้นหาจาก province
        if (queryProvince) {
          const courseQuery = await courseIndex.search(queryProvince);
          const courseIds = courseQuery.hits.map((course) => course.id);

          if (courseIds.length > 0) {
            courseIdsFilter = courseIds
              .map((id) => `courseId:"${id}"`)
              .join(" OR ");
            const caddieRequestsQuery = await caddieRequestsIndex.search(
              querySearch,
              {
                filters: `NOT status:"removed" AND (${courseIdsFilter})`,
              }
            );

            const caddieUids = caddieRequestsQuery.hits.map(
              (caddie) => caddie.caddieId
            );
            if (caddieUids.length > 0) {
              caddieUidsFilter = caddieUids
                .map((uid) => `uid:"${uid}"`)
                .join(" OR ");
              filters.push(`(${caddieUidsFilter})`);
            } else {
              setCaddieList([]); // ถ้าไม่มี caddie ที่ตรงกับ province
              setLoading(false);
              return;
            }
          }
        }

        // ค้นหาตาม querySearch และ caddieRequests
        if (querySearch) {
          const [usersQuery, caddieRequestsQuery, caddieProfileQuery] =
            await Promise.all([
              usersIndex.search(querySearch, { filters: "role:caddie" }),
              caddieRequestsIndex.search(querySearch, {
                filters: 'NOT status:"removed"',
              }),
              caddieProfilesIndex.search(querySearch),
            ]);

          const userUids = usersQuery.hits.map((user) => user.uid);
          const caddieRequestUids = caddieRequestsQuery.hits.map(
            (caddie) => caddie.caddieId
          );
          const caddieProfileUids = caddieProfileQuery.hits.map(
            (caddie) => caddie.caddieId
          );
          // console.log(caddieRequestUids)
          // console.log(caddieProfileUids)
          const allUids = [
            ...new Set([
              ...userUids,
              ...caddieRequestUids,
              ...caddieProfileUids,
            ]),
          ];
          if (allUids.length > 0) {
            filters.push(
              `(${allUids.map((uid) => `uid:"${uid}"`).join(" OR ")})`
            );
          } else {
            setCaddieList([]); // ถ้าไม่มี caddie ที่ตรงกับ province
            setLoading(false);
            return;
          }
        }

        const usersResults = await usersIndex.search("", {
          filters: filters.join(" AND "),
          page,
          hitsPerPage: 20,
        });
        // console.log(filters.join(" AND "));

        let users = usersResults.hits;
        if (users.length === 0) {
          setLoading(false);
          setHasMore(false);
          return;
        }

        const caddieUids = users.map((user) => user.uid);
        const caddieUidsQuery = caddieUids
          .map((uid) => `caddieId:"${uid}"`)
          .join(" OR ");

        const [caddieRequestsResults] = await Promise.all([
          caddieRequestsIndex.search("", { filters: `(${caddieUidsQuery})` }),
        ]);

        // const caddieProfiles = caddieProfilesResults.hits;
        // const courses = courseResults.hits;
        const caddieRequests = caddieRequestsResults.hits.filter(
          (req) => req.status !== "removed"
        );

        const validUsers = users.filter((user) =>
          caddieRequests.some((req) => req.caddieId === user.uid)
        );

        const combinedCaddies = validUsers.map((user) => {
          const caddieRequest =
            caddieRequests.find((req) => req.caddieId === user.uid) || {};

          return { ...user, caddieRequest };
        });
        // console.log(users);
        setCaddieList((prevState) =>
          page === 0 ? combinedCaddies : [...prevState, ...combinedCaddies]
        );
        setOriginalCaddieList((prevState) =>
          page === 0 ? combinedCaddies : [...prevState, ...combinedCaddies]
        );
        setHasMore(usersResults.hits.length > 0);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchCaddies();
  }, [
    page,
    triggerSearch,
    search.text.value,
    search.province.state,
    search.nearMe.state,
    sortData,
  ]);

  // console.log(triggerSearch);
  // เมื่อ page เปลี่ยน จะทำการเรียกใช้ useEffect ใหม่
  // ฟังก์ชันที่ตรวจจับเมื่อผู้ใช้เลื่อนถึงล่างสุดของหน้า
  const handleScroll = () => {
    if (
      window.innerHeight + document.documentElement.scrollTop ===
        document.documentElement.offsetHeight &&
      !loading &&
      hasMore
    ) {
      setPage((prevPage) => prevPage + 1); // เพิ่ม page เมื่อเลื่อนถึงล่างสุด
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll); // ติดตามการเลื่อนของหน้า
    return () => {
      window.removeEventListener("scroll", handleScroll); // ลบ event listener เมื่อ component ถูกลบ
    };
  }, [loading, hasMore]);

  const handleShow = async (docID) => {
    setFavoriteFriends(false);
    setShow(true);

    const docRef = doc(firestore, "users", docID);
    const docSnap = await getDoc(docRef);

    if (!docSnap.exists()) return;

    let isFriend = false;
    const userUID = docSnap.data().uid;

    if (userUID) {
      const [querySnapshot2, querySnapshot3] = await Promise.all([
        getDocs(
          query(
            collection(firestore, "friends"),
            where("friendId", "==", userUID),
            where("userId", "==", userData?.uid)
          )
        ),
        getDocs(
          query(
            collection(firestore, "friends"),
            where("friendId", "==", userData?.uid),
            where("userId", "==", userUID)
          )
        ),
      ]);

      isFriend =
        querySnapshot2.docs.some((doc) => doc.data().status === "active") ||
        querySnapshot3.docs.some((doc) => doc.data().status === "active");
    }

    const querySnapshotCaddieAssignments = await getDocs(
      query(
        collection(firestore, "caddieRequests"),
        where("caddieId", "==", userUID)
      )
    );

    let caddieNumber = null;
    let courseData = null;

    if (!querySnapshotCaddieAssignments.empty) {
      const firstDoc = querySnapshotCaddieAssignments.docs[0]; // ใช้เอกสารแรกที่พบ
      caddieNumber = firstDoc.data().caddieNumber;

      const courseRef = doc(firestore, "courses", firstDoc.data().courseId);
      const courseSnap = await getDoc(courseRef);

      if (courseSnap.exists()) {
        courseData = { ...courseSnap.data(), courseId: courseSnap.id };
      }
    }

    setCaddieData({ isFriend, caddieNumber, ...docSnap.data() });
    if (courseData) setCourseData(courseData);

    // ดึงข้อมูลโปรไฟล์แคดดี้
    const querySnapshotCaddieProfiles = await getDocs(
      query(
        collection(firestore, "caddieProfiles"),
        where("caddieId", "==", userUID)
      )
    );

    let caddieProfileData = null;
    if (!querySnapshotCaddieProfiles.empty) {
      const caddieProfileDoc = querySnapshotCaddieProfiles.docs[0];
      const imageCollection = await getDocs(
        collection(firestore, "caddieProfiles", caddieProfileDoc.id, "image")
      );

      const listImage = [
        { imageUrl: docSnap.data()?.profileImage, isPrimary: true, order: 0 },
        ...imageCollection.docs.map((doc) => doc.data()),
      ];

      caddieProfileData = { ...caddieProfileDoc.data(), image: listImage };
    } else {
      caddieProfileData = {
        ...docSnap.data(),
        image: [
          { imageUrl: docSnap.data()?.profileImage, isPrimary: true, order: 0 },
        ],
      };
    }

    setCaddieProfile(caddieProfileData);

    // ตรวจสอบ favoriteFriends
    if (userUID) {
      const querySnapshot = await getDocs(
        query(
          collection(firestore, "favoriteFriends"),
          where("caddieId", "==", userUID),
          where("userId", "==", userData.uid)
        )
      );

      setFavoriteFriends(
        querySnapshot.docs.some((doc) => doc.data().status === "active")
      );
    }
  };

  const handleSwitchChange = (checked, switchId) => {
    setTempSortData((prevState) => ({
      ...prevState,
      [switchId]: { ...prevState[switchId], state: checked },
    }));
  };

  const handleSubmit = () => {
    setPage(0);
    setHasMore(true);
    setSortData(tempSortData);
    handleCloseSortAndFilter();
  };

  const [showSortAndFilter, setShowSortAndFilter] = useState(false);
  const handleCloseSortAndFilter = () => {
    setTempSortData(sortData);
    setShowSortAndFilter(false);
  };
  const handleShowSortAndFilter = () => {
    setTempSortData(sortData);

    setShowSortAndFilter(true);
  };

  const handleInputChange = (e, field, type) => {
    const value = e && e.target ? e.target.value : e;
    setTempSortData((prevState) => ({
      ...prevState,
      [field]: { ...prevState[field], [type]: value },
    }));
  };

  const [favoriteFriends, setFavoriteFriends] = useState(false);

  const [checkIsRequestToCourse, setCheckIsRequestToCourse] = useState("");
  const [trigerDebug, setTrigerDebug] = useState(false);
  useEffect(() => {
    if (userData?.role === "caddie") {
      const q = query(
        collection(firestore, "caddieRequests"),
        where("caddieId", "==", userData.uid)
      );

      const unsubscribe = onSnapshot(q, (querySnapshot) => {
        if (querySnapshot.size === 0) {
          setCheckIsRequestToCourse("");
        } else {
          querySnapshot.forEach((doc) => {
            const status = doc.data().status;
            if (status === "pending") {
              setCheckIsRequestToCourse("pending");
            } else if (status === "approved") {
              setCheckIsRequestToCourse("approved");
            } else if (status === "rejected") {
              setCheckIsRequestToCourse("rejected");
            }
          });
        }
      });

      // Cleanup subscription on unmount
      return () => unsubscribe();
    }
  }, [userData, trigerDebug]);

  const handleChat = async (dooNineId) => {
    const result = await ChatTo(userData.dooNineId, dooNineId);
    if (result) {
      navigate("/chat-room?channelId=" + result[0].channel_url);
    }
  };

  useEffect(() => {
    const fav = [];

    async function getFavUserCaddie() {
      const caddieQuery = query(
        collection(firestore, "favoriteFriends"),
        where("userId", "==", userData.uid),
        where("status", "==", "active")
      );

      const querySnapshot = await getDocs(caddieQuery);

      if (!querySnapshot.empty) {
        querySnapshot.forEach((doc) => {
          fav.push(doc.data().caddieId);
        });
      }
    }

    async function getFavUser() {
      const playerQuery = query(
        collection(firestore, "favoritePlayers"),
        where("userId", "==", userData.uid),
        where("status", "==", "active")
      );

      const querySnapshot = await getDocs(playerQuery);

      if (!querySnapshot.empty) {
        querySnapshot.forEach((doc) => {
          fav.push(doc.data().playerId);
        });
      }
    }

    if (userData) {
      getFavUserCaddie();
      getFavUser();

      setFavoriteFriendsList(fav);
    }
  }, [userData]);

  const handleFav = async (isCaddie, friendId, favType) => {
    if (userData && friendId) {
      if (favType === "fav") {
        if (isCaddie === "caddie") {
          setFavoriteFriendsList((prev) => [...prev, friendId]);
          const isFav = await favFriendCaddie(userData?.uid, friendId);
        } else {
          setFavoriteFriendsList((prev) => [...prev, friendId]);
          const isFav = await favFriend(userData?.uid, friendId);
        }
      } else {
        if (isCaddie === "caddie") {
          setFavoriteFriendsList((prev) =>
            prev.filter((id) => id !== friendId)
          );
          const isUnFav = await favFriendCaddie(userData?.uid, friendId);
        } else {
          setFavoriteFriendsList((prev) =>
            prev.filter((id) => id !== friendId)
          );
          const isUnFav = await favFriend(userData?.uid, friendId);
        }
      }
    }
  };

  return (
    <>
      <Header />
      <Leftnav />
      <Rightchat />

      <div className="main-content right-chat-active">
        <div className="middle-sidebar-bottom">
          <div className="middle-sidebar-left pe-0">
            <div className="row">
              <div className="col-xl-12 pageCaddie">
                <div className="card shadow-xss w-100 d-block d-flex border-0 mb-1">
                  <div className="d-flex w-100 flex-column flex-md-row p-3">
                    <h2 className="d-flex fw-700 mb-2 mb-md-0 mt-0 font-md text-grey-900 align-items-center">
                      {t(textConvert("caddies"))}
                    </h2>

                    <div className="d-inline-flex align-items-center gap-2 ms-md-auto align-items-stretch">
                      <div className="flex-grow-1">
                        <CaddieSearch
                          search={search}
                          setSearch={setSearch}
                          openSearch={openSearch}
                          setOpenSearch={setOpenSearch}
                          setTriggerSearch={setTriggerSearch}
                          setPage={setPage}
                          setHasMore={setHasMore}
                          searchInput={searchInput}
                          setSearchInput={setSearchInput}
                        ></CaddieSearch>
                      </div>

                      <button
                        className="btn btn-light"
                        onClick={() => handleShowSortAndFilter()}
                      >
                        <i className="feather-filter font-xss text-grey-500"></i>
                      </button>

                      {/* <div
                        onClick={() => handleShowSortAndFilter()}
                        style={{ cursor: "pointer" }}
                        className="btn-round-md ms-2 bg-greylight theme-dark-bg rounded-3"
                      >
                        <i className="feather-filter font-xss text-grey-500"></i>
                      </div> */}
                    </div>
                  </div>

                  <StackFilter
                    trueStates={trueStates}
                    sortData={sortData}
                    setSortData={setSortData}
                    setTempSortData={setTempSortData}
                    search={search}
                    setSearch={setSearch}
                    originalCaddieList={originalCaddieList}
                    setTriggerSearch={setTriggerSearch}
                    setHasMore={setHasMore}
                    setPage={setPage}
                    searchInput={searchInput}
                    setSearchInput={setSearchInput}
                  ></StackFilter>

                  {/* {!loading ? (
                    <div className="row gx-1 ps-1 pe-1">
                      {filteredCaddieList.map((value, index) => (
                        <>
                          <CaddieCard
                            value={value}
                            index={index}
                            handleShow={handleShow}
                            handleChat={handleChat}
                            favoriteFriendsList={favoriteFriendsList}
                            handleFav={handleFav}
                            setSelectedUserLabel={setSelectedUserLabel}
                            setShowLabelModal={setShowLabelModal}
                          ></CaddieCard>
                        </>
                      ))}
                    </div>
                  ) : (
                    <div className="d-flex justify-content-center p-5">
                      <LoadCircle size="lg" variant="dark" />
                    </div>
                  )} */}

                  <div className="row gx-1 ps-1 pe-1">
                    {caddieList.length > 0 ? (
                      caddieList.map((value, index) => (
                        <CaddieCard
                          key={index}
                          value={value}
                          index={index}
                          handleShow={handleShow}
                          handleChat={handleChat}
                          favoriteFriendsList={favoriteFriendsList}
                          handleFav={handleFav}
                          setSelectedUserLabel={setSelectedUserLabel}
                          setShowLabelModal={setShowLabelModal}
                        />
                      ))
                    ) : !loading ? (
                      <h5 className="text-center p-2">No caddie available</h5>
                    ) : null}

                    {loading && (
                      <div className="d-flex justify-content-center">
                        <Load />
                      </div>
                    )}

                    {error && (
                      <div className="text-center text-danger">
                        <h5>{error.message}</h5>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal Caddie detail */}
      {show && (
        <ModalCaddieDetail
          show={show}
          setShow={setShow}
          caddieData={caddieData}
          setCaddieData={setCaddieData}
          setCourseData={setCourseData}
          setFavoriteFriends={setFavoriteFriends}
          favoriteFriends={favoriteFriends}
          courseData={courseData}
          caddieProfile={caddieProfile}
          setCaddieProfile={setCaddieProfile}
        ></ModalCaddieDetail>
      )}

      <Label
        triggerFriendList={triggerFriendList}
        setTriggerFriendList={setTriggerFriendList}
        showLabelModal={showLabelModal}
        setShowLabelModal={setShowLabelModal}
        setSelectedUserLabel={setSelectedUserLabel}
        selectedUserLabel={selectedUserLabel}
        userLabels={userLabels}
        triggerGetLabel={triggerGetLabel}
        setTriggerGetLabel={setTriggerGetLabel}
      />

      {/* Modal Filter */}
      <ModalFilter
        showSortAndFilter={showSortAndFilter}
        setShowSortAndFilter={setShowSortAndFilter}
        handleCloseSortAndFilter={handleCloseSortAndFilter}
        tempSortData={tempSortData}
        handleSubmit={handleSubmit}
        handleSwitchChange={handleSwitchChange}
        handleInputChange={handleInputChange}
        userLabels={userLabels}
      />

      <Popupchat />
      <Appfooter />
    </>
  );
}

export default Caddie;

export const Hit = ({ hit }) => {
  return (
    <article>
      <div className="hit-description">
        <Highlight attribute="description" hit={hit} />
      </div>
    </article>
  );
};

function debounce(func, delay) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), delay);
  };
}
